import React from "react";
import { Intent } from "../../../../../model/intent/types";
import { getDuplicateExpression } from "../../../../../helpers/intentHelper";
import { Alert } from "antd";

type IntentAlertProps = {
    intent: Intent;
};

const renderWarningMessage = (duplicateExpression: string []) => {
    return <div style={{display:'flex', flexDirection: 'column'}}>
        <div>Cette intention contient des expressions doublons !</div>
        {
            duplicateExpression.map((item) => {
                return <div>- {item}</div>;
            })
        }
    </div>
}

const IntentAlert: React.FunctionComponent<IntentAlertProps> = ({ intent }) => {
    const duplicateExpression = intent ? getDuplicateExpression(intent) : [];
    return duplicateExpression.length > 0 ? <Alert
        style={{ marginTop: "10px" }}
        message="Attention!"
        description={renderWarningMessage(duplicateExpression)}
        type="warning"
        showIcon
        closable
    /> : null
};

export default IntentAlert;